import { useRecoilState } from "recoil";
import { modalMetadadoState } from "../../atom";

const useModalMetadadoState = () => {
    return useRecoilState(modalMetadadoState);
};

export default useModalMetadadoState;